"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionsFor = void 0;
const Event_1 = __importDefault(require("@opsbase/lib-event/Event"));
const WorkflowActionType_1 = __importDefault(require("./WorkflowActionType"));
const actionList = {
    AssignIssue: {
        workflowActionType: WorkflowActionType_1.default.ASSIGN_ISSUE,
        workflowActionConfig: {
            assignTo: { id: '', title: '' },
        },
    },
    SetIssueDeadline: {
        workflowActionType: WorkflowActionType_1.default.SET_ISSUE_DEADLINE,
        workflowActionConfig: {
            duration: undefined,
            unit: 'hour',
        },
    },
    SendMail: {
        workflowActionType: WorkflowActionType_1.default.SEND_EMAIL,
        workflowActionConfig: {
            sendTo: [],
            subject: '',
            body: '',
        },
    },
    NotifyOp: {
        workflowActionType: WorkflowActionType_1.default.NOTIFY_OP,
        workflowActionConfig: {
            notifyTo: [],
            notifyPlaceAdmin: false,
            notifyPrimaryAdmin: false,
            notifyOpPerformer: false,
            notifyAssignee: false,
        },
    },
    NotifyIssue: {
        workflowActionType: WorkflowActionType_1.default.NOTIFY_ISSUE,
        workflowActionConfig: {
            notifyTo: [],
            notifyPlaceAdmin: false,
            notifyPrimaryAdmin: false,
            notifyAssignee: false,
            notifyCreator: false,
        },
    },
    NotifyAsset: {
        workflowActionType: WorkflowActionType_1.default.NOTIFY_ASSET,
        workflowActionConfig: {
            notifyTo: [],
        },
    },
    RaiseAnIssue: {
        workflowActionType: WorkflowActionType_1.default.RAISE_ISSUE,
        workflowActionConfig: {},
    },
    AssignOp: {
        workflowActionType: WorkflowActionType_1.default.ASSIGN_OP,
        workflowActionConfig: {
            opDefinition: { id: '', title: '' },
            assignTo: {
                allStaff: false,
                allSelected: false,
                staff: [],
                team: [],
                position: [],
            },
            due: 60,
            whenCanStart: 60,
            whenCanView: 480,
        },
    },
    AssignOpIssueClosed: {
        workflowActionType: WorkflowActionType_1.default.ASSIGN_OP_ISSUE_CLOSED,
        workflowActionConfig: {
            opDefinition: { id: '', title: '' },
            assignTo: {
                allStaff: false,
                allSelected: false,
                staff: [],
                team: [],
                position: [],
            },
            assignToIssueCloser: false,
            due: 60,
            whenCanStart: 60,
            whenCanView: 480,
        },
    },
    SendSMS: {
        workflowActionType: WorkflowActionType_1.default.SEND_SMS,
        workflowActionConfig: {
            sendTo: ['+44.'],
            message: '',
        },
    },
    IQMCreateWorkflow: {
        workflowActionType: WorkflowActionType_1.default.IQM_CREATE_WORKFLOW,
        workflowActionConfig: {
            workflowDefinitionId: undefined,
            fieldMappings: {},
        },
    },
};
function actionsFor(eventType) {
    switch (eventType) {
        case Event_1.default.ISSUE_CREATED:
            return [
                actionList.AssignIssue,
                actionList.SetIssueDeadline,
                actionList.SendMail,
                actionList.NotifyIssue,
                actionList.AssignOp,
                actionList.SendSMS,
                actionList.IQMCreateWorkflow,
            ];
        case Event_1.default.ISSUE_MISSED:
        case Event_1.default.ISSUE_COMMENT:
        case Event_1.default.ISSUE_STATUS_CHANGED:
            return [
                actionList.AssignIssue,
                actionList.SetIssueDeadline,
                actionList.SendMail,
                actionList.NotifyIssue,
                actionList.AssignOp,
                actionList.SendSMS,
            ];
        case Event_1.default.ISSUE_ASSIGNED:
            return [
                actionList.SetIssueDeadline,
                actionList.SendMail,
                actionList.NotifyIssue,
                actionList.AssignOp,
                actionList.SendSMS,
            ];
        case Event_1.default.ISSUE_CLOSED:
            return [
                actionList.SendMail,
                actionList.NotifyIssue,
                actionList.AssignOpIssueClosed,
                actionList.SendSMS,
            ];
        case Event_1.default.OP_MISSED:
        case Event_1.default.OP_COMPLETE:
        case Event_1.default.OP_LATE:
        case Event_1.default.OP_DUE:
            return [
                actionList.SendMail,
                actionList.NotifyOp,
                actionList.RaiseAnIssue,
                actionList.AssignOp,
                actionList.SendSMS,
            ];
        case Event_1.default.SENSOR_READING:
        case Event_1.default.SCHEDULE:
            return [
                actionList.SendMail,
                actionList.NotifyAsset,
                actionList.RaiseAnIssue,
                actionList.AssignOp,
                actionList.SendSMS,
            ];
        default:
            return [];
    }
}
exports.actionsFor = actionsFor;
exports.default = actionsFor;
